// extracted by mini-css-extract-plugin
export var container = "PreguntasFrecuentes-module--container--65c4b";